import React, { useEffect, useState } from 'react';
import BtnSimpl from '../../components/buttons/BtnSimpl';
import { Col, Empty, Row, Spin, Table } from 'antd';
import "./formulaires.css";
import FormBuilder from '../../components/forms/FormBuilder';
import { useDispatch, useSelector } from 'react-redux';
import { ListFormsActions } from '../../redux/actions/ListFormsActions';
import DetailsForm from './DetailsForm';
import { LoadingOutlined } from '@ant-design/icons';
import BarreRecherche from '../../components/buttons/BarreRecherche';

const Formulaires = () => {

    const [view, setView] = useState("list"); // "list", "create", "details"

    const dispatch = useDispatch();
    const {formulaires, loading : loadingListForms} = useSelector((state) => state.listeDesFormulaires);
      useEffect(() => {
    dispatch(ListFormsActions());
  }, [dispatch]);
    // console.log(formulaires); 
     const columns = [
      {
        title: 'Formulaires',
        dataIndex: 'formulaires',
        key: 'title',
        // render: (text, record) => (
        //     <span
        //     onClick={() => handleViewForm(formulaires[record.key])}
        //     style={{ cursor: 'pointer', fontWeight: 400 }}
        //     >
        //     {text}
        //     </span>
        // ),
        },
        {
            title: 'Réponses',
            dataIndex: 'responseCount',
            key: 'responseCount',
             render: (text) => (
            <span>
            {text} réponses
            </span>
        ),
        },
        
        ];
    const dataSource = formulaires.map((form, index) => ({
    key: index,
    formulaires: form.title,
    responseCount: form.responseCount,
    questions: form.fields?.length || 0,
    }));

   const [searchValue, setSearchValue] = useState('');
        const filtrData = dataSource?.filter(item =>
          item?.formulaires.toLowerCase().includes(searchValue.toLowerCase())
          );

    const [selectedForm, setSelectedForm] = useState(null);

    const handleViewForm = (form) => {
    setSelectedForm(form);
    setView("details"); 
   
    };
// console.log(selectedForm);
    
        const handleOpenFormB8ld = () => {
            setView("create");
        }
const customSpinIndicator = <LoadingOutlined  style={{ fontSize: 70, color: '#43CE0C' }} spin />;
const handleFormCreated = (newForm) => {
  setSelectedForm(newForm);
  setView("details");
};

    return (
        <div className='divGl'>
               {view === "list" && (
                <Row gutter={10}>
                    <div style={{display:"flex", alignItems:"center", justifyContent: "flex-end", width: '100%',   }}>
                        <Col span={20} >
                                <BarreRecherche type="text" 
                                //  value={searchValue} 
                                onChange={(e) => setSearchValue(e.target.value)} 
                                allowClear  />
                        </Col>
                        <Col span={4}  style={{ marginBottom:"3%",}}>
                            <BtnSimpl  buttonText_="Créer un formulaire" backgroundColor_="#43CE0C" 
                            htmlType_="button" borderRadius_="0.5rem" border_={true}
                            color_="#ffffff" onClick_={handleOpenFormB8ld}
                            boldColor_="bold" width_="100%" height_="6vh" />
                        </Col>
                    </div>
                   
                    <Col span={24}>
                     {loadingListForms ? (
                        <Spin  indicator={customSpinIndicator}  style={{ position: 'absolute',  top: '75%', left: '45%', transform: 'translate(-50%, -50%)' }} 
                        />
                    ) : ( 
                        <Table bordered showHeader={false} dataSource={filtrData} columns={columns} className='tableauT' 
                         locale={{ emptyText: <Empty description="Aucune donnée disponible" /> }}
                          onRow={(record, rowIndex) => {
                         return { onClick: () => handleViewForm(formulaires[record.key]), style: { cursor: 'pointer' },  }; }}
                         />
                         )}
                        </Col>
                </Row> )}
                      
               { view === "create" && (<Row>
                    <Col span={24} ><FormBuilder onRetour={() => setView("list")} onSuccess={handleFormCreated}  /></Col>
                </Row>)}
                   
               {view === "details" && selectedForm && (
                    <Row>
                        <Col span={24}>
                        <DetailsForm
                            onRetour={() => {
                            setView("list");
                            setSelectedForm(null); 
                            }}
                            dataForm={selectedForm} 
                        />
                        </Col>
                    </Row>
                    )}

        </div>
    );
};

export default Formulaires;